import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchVendors } from "../state/slices/vendorSlice";

const VendorsList = () => {
  const dispatch = useDispatch();
  const vendorsMap = useSelector((state) => state.vendors.vendors);
  const status = useSelector((state) => state.vendors.status);

  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    dispatch(fetchVendors());
  }, [dispatch]);

  const allVendors = Object.values(vendorsMap || {});

  const filteredVendors = searchQuery
    ? allVendors.filter((v) =>
        v.vendor_name?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : allVendors;

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchQuery(searchInput.trim());
  };

  const handleClear = () => {
    setSearchInput("");
    setSearchQuery("");
  };

  return (
    <section className="vendors-list py-80">
      <div className="container container-lg">
        <div className="flex-between flex-wrap gap-8 mb-40">
          <span className="text-neutral-600 fw-medium px-40 py-12 rounded-pill border border-neutral-100">
            Showing {filteredVendors.length} result{filteredVendors.length !== 1 ? "s" : ""}
            {searchQuery && ` for "${searchQuery}"`}
          </span>
          <div className="flex-align gap-16">
            <form
              onSubmit={handleSearch}
              className="search-form__wrapper position-relative d-block"
            >
              <input
                type="text"
                className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                placeholder="Search vendors by name..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <button
                type="submit"
                className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
              >
                <i className="ph ph-magnifying-glass" />
              </button>
            </form>
            {searchQuery && (
              <button
                type="button"
                onClick={handleClear}
                className="text-neutral-600 fw-medium px-16 py-12 rounded-pill border border-neutral-100 bg-white hover-bg-main-600 hover-text-white"
                style={{ whiteSpace: "nowrap", fontSize: 13 }}
              >
                Clear Search
              </button>
            )}
          </div>
        </div>

        {status === "loading" && (
          <div className="text-center py-80">
            <p className="text-neutral-600 fw-medium">Loading vendors...</p>
          </div>
        )}

        {status !== "loading" && filteredVendors.length === 0 && (
          <div className="text-center py-80">
            <i className="ph ph-storefront" style={{ fontSize: 48, color: "#c4cdd8", display: "block", marginBottom: 16 }} />
            <p className="text-neutral-600 fw-medium mb-0">
              {searchQuery
                ? `No vendors found matching "${searchQuery}".`
                : "No vendors available yet."}
            </p>
            {searchQuery && (
              <button
                type="button"
                onClick={handleClear}
                className="mt-16 text-main-600 fw-medium"
                style={{ background: "none", border: "none", cursor: "pointer", textDecoration: "underline" }}
              >
                Clear search
              </button>
            )}
          </div>
        )}

        {filteredVendors.length > 0 && (
          <div className="row gy-4 vendor-card-wrapper">
            {filteredVendors.map((vendor) => (
              <div key={vendor.id} className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="vendor-card text-center px-16 pb-24">
                  <div>
                    {vendor.image ? (
                      <img
                        src={vendor.image}
                        alt={vendor.vendor_name}
                        className="vendor-card__logo m-12"
                        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: "50%" }}
                      />
                    ) : (
                      <div
                        className="vendor-card__logo m-12 flex-center"
                        style={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background: "#eef4ff",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i className="ph ph-storefront" style={{ fontSize: 32, color: "#2575fc" }} />
                      </div>
                    )}
                    <h6 className="title mt-32">
                      <Link to={`/vendor/${vendor.id}`}>
                        {vendor.vendor_name}
                      </Link>
                    </h6>
                    {vendor.city && vendor.state && (
                      <span className="text-heading text-sm d-block">
                        {vendor.city}, {vendor.state}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default VendorsList;
